import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useEhrContext } from "../../../shared-logic/ehr-context/ehr-context";
import { BaseTableLayout } from "../../components/base-table-layout";
import { TableFilterPopover } from "../../components/table-filter-popover";
import { useTableFilters } from "../../hooks/use-table-filters";
import { TableRow } from "../../utils/tables-metadata";
import { ImagingReportRowData } from "./imaging-reports-rows";
import { useImagingColumns, useImagingFilterOptions } from "./imaging-shared";

export type BrowseImagingReportsTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  displayName: string;
  onPdfView?: (docId: string) => void;
  isRowViewed?: (row: TableRow) => boolean;
};

/**
 * Imaging reports table component for browse mode.
 * Uses BaseTableLayout with standard table styling.
 * Parent provides the card wrapper.
 */
export function BrowseImagingReportsTable({
  rows,
  onRowClick,
  filterQuery,
  displayName,
  isRowViewed,
}: BrowseImagingReportsTableProps) {
  const ehrContext = useEhrContext();
  const columns = useImagingColumns(ehrContext);
  const filterOptions = useImagingFilterOptions(rows);

  const { activeFilters, setActiveFilters, filteredRows } = useTableFilters(rows, filterOptions);

  function handleRowClick(row: ImagingReportRowData) {
    onRowClick(row);
  }

  return (
    <BaseTableLayout
      title={displayName}
      rows={filteredRows as ImagingReportRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
      isRowViewed={isRowViewed}
      headerActionsSlot={
        filterOptions.length > 0 ? (
          <TableFilterPopover
            filters={filterOptions}
            activeFilters={activeFilters}
            setActiveFilters={newFilters => setActiveFilters(newFilters)}
          />
        ) : undefined
      }
    />
  );
}
